import { render, staticRenderFns } from "./stopPage.vue?vue&type=template&id=6dcecfb9&scoped=true&"
import script from "./stopPage.vue?vue&type=script&lang=js&"
export * from "./stopPage.vue?vue&type=script&lang=js&"
import style0 from "./stopPage.vue?vue&type=style&index=0&id=6dcecfb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcecfb9",
  null
  
)

export default component.exports